import React from 'react';
import ImageWithFallback from '../../../uiToolkit/ImageWithFallback/ImageWithFallback';
import styles from './EditMediaItemCard.module.css';

interface Props {
  thumbnailUrl: string;
  title: string;
  duration: number;
  selected: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const formatDuration = (seconds: number) => {
  const s = Math.max(0, Math.round(seconds));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(m)}:${pad(sec)}`;
};

const EditMediaItemCard = React.memo(
  ({thumbnailUrl, title, duration, selected, disabled, onClick}: Props) => (
    <div
      className={`${styles.card} ${selected ? styles.cardSelected : ''}`}
      onClick={() => !disabled && onClick()}>
      <div className={styles.poster}>
        <ImageWithFallback src={thumbnailUrl} />
        {selected && (
          <div className={styles.checkOverlay}>
            <div className={styles.checkBadge}>
              <span className="icon-check" />
            </div>
          </div>
        )}
      </div>
      <div className={styles.info}>
        <p className={styles.title} title={title}>
          {title}
        </p>
        {duration > 0 && (
          <span className={styles.duration}>{formatDuration(duration)}</span>
        )}
      </div>
    </div>
  ),
);

export default EditMediaItemCard;
